module.exports = __webpack_public_path__ + "static/media/mauritius-flag-round-small.8353fd7b.jpg";